import { CoreButton, CoreInput } from '@components'
import { ExternalWalletTypes, useEditExternalWalletQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { useEffect } from 'react'

interface SkrillRecipientEditProps {
  recipientId?: number
  currencyCode?: string
  onSuccess?: (response: any) => void
  onClose: () => void
}

export const SkrillRecipientEdit = ({ recipientId, currencyCode, onClose, onSuccess }: SkrillRecipientEditProps) => {
  const { formValues, handleSubmit, error, fetching, resetMutations } = useEditExternalWalletQry({
    type: ExternalWalletTypes.SKRILL,
    recipientId,
    currencyCode,
    onClose,
    onSuccess
  })

  const handleSubmitInternal = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    handleSubmit()
  }

  useEffect(() => {
    return () => {
      resetMutations()
    }
  }, [])

  return (
    <div className='recipient-edit-wrapper'>
      <div className='recipient-edit-title'>{tr('FRONTEND.CUSTOMERS.EDIT.TITLE_PERSONAL', 'Personal information')}</div>
      <form className='recipient-edit-form' noValidate>
        <CoreInput
          type='email'
          data-test='email'
          label={tr('FRONTEND.LOGIN.EMAIL', 'Email')}
          {...formValues.registerInput('email')}
          autoComplete='off'
        />
        <CoreInput
          type='text'
          data-test='identifier'
          label={tr('FRONTEND.RECIPIENTS.JETON.IDENTIFIER', 'Identifier')}
          {...formValues.registerInput('identifier')}
          autoComplete='off'
        />
        <CoreInput
          type='text'
          data-test='name'
          label={tr('FRONTEND.PROFILE.FULL_NAME', 'Name')}
          {...formValues.registerInput('name')}
          autoComplete='off'
        />

        <ErrorDisplay error={[error]} />

        <div className='recipient-edit-actions'>
          <CoreButton
            data-test='save-button'
            type='button'
            variation='primary-black'
            size='large'
            fullWidth
            text={tr('FRONTEND.COOKIE_CONSENT.SAVE', 'Save')}
            className='save-button'
            onClick={async e => {
              e.preventDefault()
              await handleSubmitInternal(e)
            }}
            isLoading={fetching}
          />
        </div>
      </form>
    </div>
  )
}
